const updates = [
  { time: '15分钟前', tag: '新瓜', title: '某顶流男星深夜密会神秘女子，酒店监控视频流出引热议', hot: true },
  { time: '42分钟前', tag: '跟进', title: '知名女艺人工作室发声明否认偷税漏税传闻，称已报案处理', hot: true },
  { time: '1小时前', tag: '独家', title: '综艺节目录制现场突发意外，两位嘉宾当面对峙场面一度失控', hot: false },
  { time: '2小时前', tag: '热榜', title: '网红情侣分手内幕曝光，男方疑似出轨聊天记录被扒出', hot: true },
  { time: '3小时前', tag: '爆料', title: '某导演新片选角黑幕被曝光，制片人私下收受好处费', hot: false },
  { time: '4小时前', tag: '实锤', title: '知名歌手演唱会假唱证据确凿，现场观众晒出对比音频', hot: true },
  { time: '5小时前', tag: '热议', title: '影视公司老板被举报性骚扰，多位女演员联名发声力挺受害者', hot: false },
  { time: '7小时前', tag: '独家', title: '某平台头部主播数据造假被实锤，真实在线人数不足宣称十分之一', hot: false },
  { time: '9小时前', tag: '新瓜', title: '热门综艺导师内定晋级名单提前泄露，节目组紧急公关', hot: true },
];

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">最新快讯</h2>
          <span className="text-xs text-foreground-400 mt-2">实时更新中</span>
        </div>

        <div className="relative">
          <div className="absolute left-[11px] top-2 bottom-2 w-0.5 bg-background-300"></div>
          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 pl-8 group cursor-pointer">
                <span className={`absolute left-0 top-1.5 w-[22px] h-[22px] rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
                  item.hot
                    ? 'border-primary-400 bg-primary-100'
                    : 'border-background-300 bg-background-100'
                }`}>
                  <span className={`w-2 h-2 rounded-full ${item.hot ? 'bg-primary-500' : 'bg-background-400'}`}></span>
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded whitespace-nowrap ${
                      item.tag === '新瓜' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '实锤' ? 'bg-accent-100 text-accent-800' :
                      item.tag === '独家' ? 'bg-secondary-200 text-secondary-800' :
                      'bg-background-200 text-foreground-600'
                    }`}>{item.tag}</span>
                    {item.hot && (
                      <span className="text-[10px] text-primary-500 flex items-center gap-0.5 whitespace-nowrap">
                        <i className="ri-fire-fill text-[9px]"></i>热
                      </span>
                    )}
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}